import { z } from 'zod';
import { PLAN_OZELLIKLERI, planSchema, type Plan } from '../platform.js';

/**
 * Oda yonetimi ve plan limiti.
 *
 * Oda ekleme/cikarma yetkisi `room:write`tir; OWNER ve MANAGER'da vardir,
 * resepsiyonda YOKTUR. Limit tesisin planindan gelir ve yalnizca AKTIF
 * odalar sayilir - oda "azaltmak" pasife almaktir, boylece limit gercekten
 * bosalir ve gecmis rezervasyonlar yerinde kalir.
 */

export const odaOlusturSchema = z.object({
  no: z.string().trim().min(1, 'Oda numarası gerekli').max(10),
  roomTypeId: z.string().min(1, 'Oda tipi seçin'),
  kat: z.string().trim().max(10).nullable().optional(),
  blok: z.string().trim().max(10).nullable().optional(),
});
export type OdaOlustur = z.infer<typeof odaOlusturSchema>;

export const odaGuncelleSchema = z
  .object({
    no: z.string().trim().min(1).max(10).optional(),
    roomTypeId: z.string().min(1).optional(),
    kat: z.string().trim().max(10).nullable().optional(),
    blok: z.string().trim().max(10).nullable().optional(),
    /** false = odayi kullanimdan kaldir (limitten duser, kayitlar kalir) */
    aktif: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: 'Değiştirilecek bir alan yok' });
export type OdaGuncelle = z.infer<typeof odaGuncelleSchema>;

/** Paket yukseltme talebi (kendi kendine satin alma yok, bkz. paywall). */
export const paketTalebiSchema = z.object({
  hedefPlan: planSchema,
  not: z.string().trim().max(500).optional(),
});
export type PaketTalebi = z.infer<typeof paketTalebiSchema>;

/** Plan siralamasi - kucukten buyuge. Paywall "bir ust paketi" bundan bulur. */
export const PLAN_SIRASI: Plan[] = ['DENEME', 'BASLANGIC', 'PROFESYONEL', 'KURUMSAL'];

/**
 * Bir ust paket. En ustteyse `null` doner - o zaman paywall degil,
 * "bizimle iletisime gecin" mesaji gosterilir.
 */
export function sonrakiPlan(plan: Plan): Plan | null {
  const i = PLAN_SIRASI.indexOf(plan);
  return i >= 0 && i < PLAN_SIRASI.length - 1 ? PLAN_SIRASI[i + 1]! : null;
}

export interface OdaLimitDurumu {
  plan: Plan;
  /** Su an AKTIF oda sayisi */
  kullanilan: number;
  limit: number;
  kalan: number;
  doldu: boolean;
  sonrakiPlan: Plan | null;
  sonrakiLimit: number | null;
}

export function odaLimitDurumu(plan: Plan, limit: number, kullanilan: number): OdaLimitDurumu {
  const sonraki = sonrakiPlan(plan);
  return {
    plan,
    kullanilan,
    limit,
    kalan: Math.max(0, limit - kullanilan),
    doldu: kullanilan >= limit,
    sonrakiPlan: sonraki,
    sonrakiLimit: sonraki ? PLAN_OZELLIKLERI[sonraki].odaLimiti : null,
  };
}
